import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useRef, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { EmptyIndustry } from "./EmptyIndustry";
import { IIndustryMast } from "../../models/IndustryMast";
import { Editor } from "primereact/editor";
import { Toast } from "primereact/toast";

const schema = yup.object({
    industry_Name: yup.string().required('Please enter industry'),
        description:yup.string().nullable()
});

interface Iprops {
    singleData: IIndustryMast,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

export const Form = (props: Iprops) => {
    const [tbody, setTbody] = useState("");
    const [loading, setLoading] = useState(false);

    const { control, handleSubmit, formState: { errors }, reset } = useForm<IIndustryMast>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });
    const loadDescription = async () => {
        setLoading(true);
        const response = await Fetch("Industry_Mast", "GET", null, null, toast);
        if (response) {
            const data:IIndustryMast = await response.json();
            if (data.description) setTbody(data.description);
            setLoading(false);
        } else setLoading(false);
    }
    const toast = useRef<any>(null);
    useEffect(() => {
        loadDescription();
         reset(props.singleData);
         if(props.singleData.description)
         setTbody(props.singleData.description);
    }, [props.singleData]);

    const saveToDB = async (body: IIndustryMast) => {
        
        body.description = tbody;

// console.log(body,tbody)
        const method = props.singleData.industry_Id ? "PUT" : "POST";
        const message = props.singleData.industry_Id ? "Updated Successfully" : "Added Successfully";

        const response = await Fetch("Industry_Mast", method, body,null, props.toast);
        

        if (response) {
            props.hideDialog();
            props.toast.current.show({ severity: 'success',  detail: message, life: 3000 });
            props.setReload(!props.reload);
           
        }
    }

    const onHide = () => {
        props.hideDialog();
        setTbody("")
        reset(EmptyIndustry);
    }

    function onSubmit(data: IIndustryMast) {
        if (tbody.length < 1) toast.current.show({ severity: 'error', detail: " description", life: 3000 });
        else saveToDB(data);
    }
    // console.log(tbody)

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add Industry Type" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">

                <JVInput column={1} required label="Industry Type" control={control} name="industry_Name" error={errors.industry_Name?.message} />
                <div className="col-12 md:col-12 md:col-6 mb-3">
                    <label htmlFor="tbody">Description</label>
                    <Editor style={{ height: '30vh' }} name="description" value={tbody} onTextChange={(e) => { if (e.htmlValue) setTbody(e.htmlValue) }} />
                </div>
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} label="SAVE" type="submit"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-outlined surface-200"></Button>
                </div>
            </form>
            <Toast ref={toast} />

        </Dialog>
    );
}
